import { Chip } from '@mui/material'
import { Group } from 'features/groups'
import GroupChip from './GroupChip'

function GroupsTags({
  groups: _groups,
  limitTags,
  focused,
  onDelete,
  ...otherProps
}: {
  groups: Group[]
  limitTags?: number
  focused?: boolean
  onDelete: (group: Group) => void
}) {
  const showLimitTag = limitTags && _groups.length > limitTags && !focused
  const groups = !showLimitTag ? _groups : _groups.slice(0, limitTags)

  return (
    <>
      {groups.map((group) => (
        <GroupChip key={group.id} group={group} onDelete={onDelete} {...otherProps} />
      ))}
      {showLimitTag && (
        <Chip label={`+${_groups.length - limitTags}`} size="small" variant="outlined" color="default" />
      )}
    </>
  )
}

export default GroupsTags
